/* cspell:disable */
import { UserData } from '@root/hooks/useUserData';
import style from '@root/scss/eurasia36/index.module.scss';

type CardInfoProps = {
  userData: UserData | null;
};

export const CardInfo = (props: CardInfoProps) => {
  const { userData } = props;

  if (userData) {
    const { fee, payAmount, fullAmount } = userData;
    return (
      <div style={{ marginBottom: '25px' }}>
        <h2 className={style.card_info__title}>
          Добровольное комплексное страхование
        </h2>
        <div>
          <div
            className={style.blockForm__top}
            style={{ marginBottom: '18px' }}
          >
            <p className={style.card_info__label}>Страховая премия:</p>
            <p className={style.card_info__value}>{fullAmount} &#8376;</p>
          </div>
          <div
            className={style.blockForm__top}
            style={{ marginBottom: '18px' }}
          >
            <p className={style.card_info__label}>Сумма комиссии провайдера:</p>
            <p className={style.card_info__value}>{fee} &#8376;</p>
          </div>
          <div
            className={style.blockForm__top}
            style={{ marginBottom: '18px' }}
          >
            <p className={style.card_info__label}>Сумма к оплате:</p>
            <p className={style.card_info__value}>{payAmount} &#8376;</p>
          </div>
          {/* <h2 className={style.card_info__subtitle}>
            Выберите вариант для оплаты за страховой полис
          </h2> */}
        </div>
      </div>
    );
  }

  return null;
};
